import React from 'react'
import { AlertDialog, AlertDialogFooter, AlertDialogDescription, AlertDialogContent, AlertDialogHeader, AlertDialogTitle } from 'components/ui/alert-dialog'
import { Button } from 'components/ui/button'
import { useTranslation } from 'react-i18next';

interface MemoryAlertDialogProps {
    deleteDialogOpen: boolean;
    setDeleteDialogOpen: (deleteDialogOpen: boolean) => void;
    memoryToDelete: { id: string; text: string } | null;
    handleConfirmDelete: () => void;
    isDeleting: boolean;
}
function MemoryDeleteAlertDialog({ deleteDialogOpen, setDeleteDialogOpen, memoryToDelete, handleConfirmDelete, isDeleting }: MemoryAlertDialogProps) {
    const { t } = useTranslation();
    return (
        <AlertDialog open={deleteDialogOpen} onOpenChange={setDeleteDialogOpen}>
            <AlertDialogContent nested className="max-w-md">
                <AlertDialogHeader>
                    <AlertDialogTitle>{t('DELETE_MEMORY') || 'Delete Memory'}</AlertDialogTitle>
                    <AlertDialogDescription className='text-sm font-light'>
                        {t('DELETE_MEMORY_DESCRIPTION') || 'Are you sure you want to delete'} {memoryToDelete && (
                            <span className="font-medium">
                                &ldquo;{memoryToDelete.text}&rdquo;
                            </span>
                        )}? {t('DELETE_MEMORY_DESCRIPTION_2') || 'This action cannot be undone.'}

                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <Button
                        variant="outline"
                        onClick={() => setDeleteDialogOpen(false)}
                        disabled={isDeleting}
                    >
                        {t('CANCEL') || 'Cancel'}
                    </Button>
                    <Button
                        variant="destructive"
                        onClick={handleConfirmDelete}
                        disabled={isDeleting}
                        loading={isDeleting}
                    >
                        {t('DELETE') || 'Delete'}
                    </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}

export default MemoryDeleteAlertDialog